import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { Windows11AssessmentRoutingModule } from './windows-11-assessment-routing.module';
import { Windows11AssessmentComponent } from './windows-11-assessment.component';
import { MarketingService } from '../services/marketing.service';
import { SharedModule } from '../shared/shared.module';
import { NgProgressModule } from 'ngx-progressbar';
import { NgDragDropModule } from 'ng-drag-drop';
// import { RouteTransformerDirective } from './routeTransformerDirective';
import { MatSortModule } from '@angular/material/sort';
import { MatCardModule } from '@angular/material/card';
import { ChildHeaderModule } from '../child-header/child-header.module';
import { BreadcrumbModule } from '../breadcrumb/breadcumb.module';
import { Windows11ReportComponent } from './report/windows-11-report.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Windows11ReportTopComponent } from './report-top-section/windows-11-report-top.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { Windows11ReportExtractComponent } from './report/report-extract/windows-11-report-extract.component';
import { Windows11AssessmentService } from '../services/windows-11-assessment.service';


@NgModule({
  imports: [
    BrowserModule,
    CommonModule, 
    NgbModule,
    SharedModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    NgProgressModule,
    MatSortModule,
    MatCardModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    MatTableModule,
    MatIconModule,
    RouterModule,
    Windows11AssessmentRoutingModule,
    NgDragDropModule.forRoot(),
    ChildHeaderModule,
    BreadcrumbModule
  ],
  declarations: [
    Windows11AssessmentComponent,
    Windows11ReportComponent,
    Windows11ReportTopComponent,
    Windows11ReportExtractComponent
  ],
  providers: [
    MarketingService,
    // Windows11AssessmentService
  ]
})
export class Windows11AssessmentModule {}
